import { Outlet } from 'react-router-dom';
import SubHeading from '../../../Components/SubHeading';
import { FaClipboardList } from 'react-icons/fa';
import TabNavs from '../../../Components/TabNavs';

const TABS = [
  {
    id: 'overall',
    title: 'Overall',
    path: 'overall'
  },
  {
    id: 'events',
    title: 'Events',
    path: 'events'
  }
];

function ReportLayout() {
  return (
    <div className="card">
      <div className="card-header">
        <SubHeading id="sidebar.report" Icon={FaClipboardList} />
        <div>
          <TabNavs tabs={TABS} />
        </div>
      </div>
      <div className="card-body">
        <Outlet />
      </div>
    </div>
  );
}

export default ReportLayout;
